<template>
    <div>
        <div class="card ">
            <div class="card-header main-card">
                Administración paradas y rutas
            </div>
            <div class="card-body">
                <div class="mb-4">
                    <span class="mr-4">
                        Selecciona grupo de actividad
                    </span>
                    <b-form-select @change="getData" v-model="activity_group_id">
                        <option value="0">Seleccione grupo...</option>
                        
                        <optgroup v-for="grouped in organizeGroups" :key="grouped.suprazone_name" :label="grouped.suprazone_name">
                            <option v-for="group in grouped.groupsList" :key="group.id" :value="group.id">{{group.name}}</option>
                        </optgroup>
                    </b-form-select>
                
                    <!-- <b-button v-if="!showAddPoint" @click="toggleShowAddPoint" variant="light" class="border">
                        Añadir un punto
                    </b-button>
                    <b-button v-if="showAddPoint" @click="toggleShowAddPoint" variant="light" class="border">
                        Esconder añadir punto
                    </b-button> -->

                    <!-- <b-button v-if="activity_group_id != 0" @click="copyStops" variant="light" class="border">
                        Crear nuevo grupo copiando 
                    </b-button> -->
                </div>
                <p v-if="activity_group_id != 0" class="text-center font-weight-bold">
                    Listado de paradas y ruta del grupo {{activity_group_current !== undefined ? activity_group_current.name : ''}}
                </p>

                <div class="flex text-center" v-if="Object.keys(grouped).length === 0 && grouped.constructor === Object && activity_group_id != 0">
                    <span class="alert-info font-weight-bold py-1 px-5">
                        Aún no hay paradas configuradas para {{activity_group_current !== undefined ? activity_group_current.name : ''}}
                    </span>
                </div>

                <div v-for="(group, idx) in grouped" :key="idx">
                    <b-container>
                        <p class="font-weight-bold">{{idx}}</p>
                        <admin-stop-schedules-table :rows="group" :activity_group="activity_group_current" />
                    </b-container>
                </div>
                



                <b-container v-if="activity_group_id != 0" class="mt-5 border-top py-5">
                    <p class="text-center font-weight-bold">
                        Puntos de la zona {{activity_group_current != undefined ? activity_group_current.suprazone_name : ''}} sin asignar a este grupo de actividad
                    </p>
                    <table class="table table-hover table-bordered table-sm mt-1 border">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Hotel</th>
                                <th scope="col">Recogida</th>
                                <th scope="col">Punto recogida</th>
                                <th scope="col">Zona</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(point, idx) in stopsNotScheduled" :key="idx">
                                <td>
                                    {{point.name}}
                                </td>
                                <td>
                                    <i v-if="point.is_hotel" class="fa fa-check-circle mr-2 text-primary" aria-hidden="true" title="Sí"></i>
                                    <i v-else class="fa fa-times mr-2 text-warning" aria-hidden="true" title="No"></i>
                                </td>
                                <td>
                                    <i v-if="point.is_pickup" class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Sí"></i>
                                    <i v-else class="fa fa-times-circle mr-2 text-danger" aria-hidden="true" title="No"></i>
                                </td>
                                <td>
                                    {{point.pickup_point != null ? point.pickup_point.name : '-'}}
                                </td>
                                <td>
                                    {{point.sub_zone.name}}
                                </td>
                                <td>
                                    <b-dropdown
                                        size="lg"
                                        variant="link"
                                        toggle-class="text-decoration-none"
                                        no-caret
                                    >
                                        <template v-slot:button-content>
                                            <i class="fa fa-ellipsis-v"></i>
                                        </template>
                                        <b-dropdown-item>
                                            <div v-b-modal="'addStopSchedule_' + point.id">
                                                <i class="fa fa-plus-circle mr-2 fa-fw"/> Añadir
                                            </div>
                                            <add-stop-schedule-modal 
                                                :item="point" 
                                                :activity_group="activity_group_current"
                                                :stops="stopsAdmin"
                                            />
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { Fragment } from 'vue-fragment'

import { mapGetters } from 'vuex';
import _ from 'lodash';
import AdminStopSchedulesTable from './AdminStopSchedulesTable'
import AdminStopsSchedulesTableRow from './AdminStopsSchedulesTableRow'
import AddStopScheduleModal from './AddStopScheduleModal'

export default {
    components: {
        Fragment,
        AdminStopSchedulesTable,
        AdminStopsSchedulesTableRow,
        AddStopScheduleModal,
    },
    data() {
        return {
            showAddPoint: false,
            activity_group_id: 0,
            activity_group_current: {},
        }
    },
    async mounted() {
        await this.$store.dispatch("groups/loadGroups")
    },
    beforeDestroy() {
        // clean table
        this.$store.commit("stops/RESET_STOPS_ADMIN")
    },
    methods: {
        async getData() {
            this.activity_group_current = this.activityGroupCurrent(this.activity_group_id)
            const data = {
                'activity_group_id': this.activity_group_id,
            }
            await this.$store.dispatch("stops/loadStopsAdmin", data)
            const data2 = {
                'activity_group_id': this.activity_group_id,
                'suprazone_id': this.activity_group_current.suprazone_id,
            }
            await this.$store.dispatch("geopoints/geoPointNotStopSchedule", data2)
            
        },
        toggleShowAddPoint() {
            this.showAddPoint = !this.showAddPoint
        },
        
        
    },
    computed: {
        ...mapGetters(['stopsAdmin', 'groups', 'geopointsWithoutStopScheduleAdmin',
                        'activityGroupCurrent', 'isDataLoading', 'suprazones']),
        grouped() {
            //let g  = _.groupBy(this.stopsAdmin, 'geo_point.sub_zone.pickup_zone')

            let g = _.mapValues(
                _.groupBy(
                    this.stopsAdmin, 'geo_point.sub_zone.pickup_zone.name'
                ),
            )
            return g
        },
        stopsNotScheduled() {
            return this.geopointsWithoutStopScheduleAdmin.filter(item => item.is_pickup == true)
        },
        organizeGroups() {
            let org = []
            for ( let i in this.suprazones ) {
                const grps = this.groups
                let fGroups = grps.filter( (group) => group.suprazone_name == this.suprazones[i].name )
                org.push({
                    suprazone_name: this.suprazones[i].name,
                    groupsList: fGroups
                })
            }

            return org
        },
    },
    watch: {
        stopsNotScheduled: function() {
        }
    }
}
</script>